import { loadMemes } from '../services/memes';

export class MemeGrid extends HTMLElement {
  constructor() {
    super();
    this.memes = [];
  }

  connectedCallback() {
    this.memes = loadMemes();
    this.render();
  }

  render() {
    this.innerHTML = `
      <div class="meme-grid">
        ${this.memes.map(meme => `
          <div class="meme-item" data-meme-id="${meme.id}">
            <img src="${meme.image}" alt="${meme.alt}" loading="lazy">
          </div>
        `).join('')}
      </div>
    `;
  }
}

// Register the custom element
customElements.define('meme-grid', MemeGrid);
